// extracted by mini-css-extract-plugin
export var burgerButton = "MenuBurger-module--burgerButton--2p9dO";
export var menuiconEnter = "MenuBurger-module--menuiconEnter--12ojG";
export var menuiconEnterActive = "MenuBurger-module--menuiconEnterActive--1HV5U";
export var menuiconEnterDone = "MenuBurger-module--menuiconEnterDone--1OWEs";
export var menuiconExit = "MenuBurger-module--menuiconExit--1Q--u";
export var menuiconExitActive = "MenuBurger-module--menuiconExitActive--1I-GC";